import { useState } from 'react';
import { EditOutlined } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateBalanceSheet_FieldsFragment } from 'queries';

import EstateBalanceSheetCalculationsForm from './estate-balance-sheet-calculations-form';
import EstateBalanceSheetCalculationsTable from './estate-balance-sheet-calculations-table';

const useStyles = makeStyles(() => ({
  container: {
    width: '460px',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '16px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gapX: '8px',
    marginBottom: '16px',
  },
}));

type Props = {
  estateBalanceSheet: EstateBalanceSheet_FieldsFragment;
};

const EstateBalanceSheetAssetCalculations = ({ estateBalanceSheet }: Props) => {
  const classes = useStyles();

  const [isEditingInputs, setIsEditingInputs] = useState(false);

  const showEstateBalanceSheetCalculationsForm =
    isEditingInputs ||
    estateBalanceSheet.federalExemptionYearOfDeathAmount == null ||
    estateBalanceSheet.exemptionUsedLastForm709 == null ||
    estateBalanceSheet.estimatedEstateTaxPercentage == null;

  return (
    <Box className={classes.container} onClick={(evt) => evt.stopPropagation()}>
      <div className={classes.header}>
        <Typography className={classes.title}>Balance Sheet Calculations</Typography>
        <IconButton aria-label="edit" onClick={() => setIsEditingInputs((val) => !val)}>
          <EditOutlined />
        </IconButton>
      </div>
      {showEstateBalanceSheetCalculationsForm ? (
        <EstateBalanceSheetCalculationsForm
          estateBalanceSheet={estateBalanceSheet}
          onSubmitCalculation={() => setIsEditingInputs(false)}
        />
      ) : (
        <EstateBalanceSheetCalculationsTable estateBalanceSheet={estateBalanceSheet} />
      )}
    </Box>
  );
};

export default EstateBalanceSheetAssetCalculations;
